import type { TransKeys } from '@/i18n/trans/index';
import { createTrans } from '@/i18n/trans/index';
import { Trans } from 'react-i18next';

export const TransText = createTrans({
  MODIFICATION_FEE: (
    <Trans i18nKey="text.MODIFICATION_FEE" defaults="Change fee" />
  ),
  PAYMENT_METHOD_FEE: (
    <Trans i18nKey="text.PAYMENT_METHOD_FEE" defaults="Payment method fee" />
  ),
  PLACE_SELECTION_FEE: (
    <Trans i18nKey="text.PLACE_SELECTION_FEE" defaults="Seat selection fee" />
  ),
  RETURN_FEE: <Trans i18nKey="text.RETURN_FEE" defaults="Refund fee" />,
  SALES_FEE: <Trans i18nKey="text.SALES_FEE" defaults="Booking fee" />,
  SEAT_SELECTION_FEE: (
    <Trans i18nKey="text.SEAT_SELECTION_FEE" defaults="Reservation" />
  ),
  account: <Trans i18nKey="text.account" defaults="Account" />,
  accountCreated: (
    <Trans i18nKey="text.accountCreated" defaults="Account created!" />
  ),
  accountDetails: (
    <Trans i18nKey="text.accountDetails" defaults="Account details" />
  ),
  activation: <Trans i18nKey="text.activation" defaults="Activation" />,
  active: <Trans i18nKey="text.active" defaults="Active" />,
  addExtras: <Trans i18nKey="text.addExtras" defaults="Add extras" />,
  addToWallet: <Trans i18nKey="text.addToWallet" defaults="Add to wallet" />,
  addVoucher: <Trans i18nKey="text.addVoucher" defaults="Add voucher" />,
  addedExtras: <Trans i18nKey="text.addedExtras" defaults="Added extras" />,
  additionalFees: (
    <Trans i18nKey="text.additionalFees" defaults="Additional fees" />
  ),
  alreadyHaveAnAccount: (
    <Trans
      i18nKey="text.alreadyHaveAnAccount"
      defaults="Already have an account?"
    />
  ),
  appliedCode: <Trans i18nKey="text.appliedCode" defaults="Applied code" />,
  appliedVouchers: (
    <Trans i18nKey="text.appliedVouchers" defaults="Applied vouchers" />
  ),
  apply: <Trans i18nKey="text.apply" defaults="Apply" />,
  areYouSureYouWantToCancelThePurchase: (
    <Trans
      i18nKey="text.areYouSureYouWantToCancelThePurchase"
      defaults="Are you sure you want to cancel the purchase?"
    />
  ),
  arrival: <Trans i18nKey="text.arrival" defaults="Arrival" />,
  available: <Trans i18nKey="text.available" defaults="Available" />,
  availableSeat: (
    <Trans i18nKey="text.availableSeat" defaults="Available seat" />
  ),
  back: <Trans i18nKey="text.back" defaults="Back" />,
  backToJourneySearch: (
    <Trans
      i18nKey="text.backToJourneySearch"
      defaults="Back to the journey search"
    />
  ),
  birthDate: <Trans i18nKey="text.birthDate" defaults="Date of birth" />,
  bookedTravelPasses: (
    <Trans i18nKey="text.bookedTravelPasses" defaults="Booked travel passes" />
  ),
  booking: <Trans i18nKey="text.booking" defaults="Booking" />,
  bookingItems: <Trans i18nKey="text.bookingItems" defaults="Booking items" />,
  bookingNo: (
    <Trans
      i18nKey="text.bookingNo"
      defaults="Your booking number is: {{number}}"
    />
  ),
  bookingNumber: (
    <Trans i18nKey="text.bookingNumber" defaults="Booking number" />
  ),
  bookingSessionExpired: (
    <Trans
      i18nKey="text.bookingSessionExpired"
      defaults="Booking session expired"
    />
  ),
  bookingSessionExpiresIn: (
    <Trans
      i18nKey="text.bookingSessionExpiresIn"
      defaults="Booking session expires in"
    />
  ),
  bookingSessionExpiryDescription: (
    <Trans
      i18nKey="text.bookingSessionExpiryDescription"
      defaults="Your booking session has expired. Start a new session to resume the booking process."
    />
  ),
  bookingSummary: (
    <Trans i18nKey="text.bookingSummary" defaults="Booking summary" />
  ),
  bookingTotal: <Trans i18nKey="text.bookingTotal" defaults="Booking total" />,
  bus: <Trans i18nKey="text.bus" defaults="Bus" />,
  cancel: <Trans i18nKey="text.cancel" defaults="Cancel" />,
  cancelPurchase: (
    <Trans i18nKey="text.cancelPurchase" defaults="Cancel purchase" />
  ),
  cancelled: <Trans i18nKey="text.cancelled" defaults="Cancelled" />,
  changeable: <Trans i18nKey="text.changeable" defaults="Changeable" />,
  changedSeat: <Trans i18nKey="text.changedSeat" defaults="Changed seat" />,
  checkYourEmail: (
    <Trans i18nKey="text.checkYourEmail" defaults="Check your email" />
  ),
  checkout: <Trans i18nKey="text.checkout" defaults="Checkout" />,
  chooseTravelPassesToRefund: (
    <Trans
      i18nKey="text.chooseTravelPassesToRefund"
      defaults="Choose travel pass(es) to refund"
    />
  ),
  chooseTripsToRefund: (
    <Trans
      i18nKey="text.chooseTripsToRefund"
      defaults="Choose trip(s) to refund"
    />
  ),
  close: <Trans i18nKey="text.close" defaults="Close" />,
  coTravelerSeat: (
    <Trans i18nKey="text.coTravelerSeat" defaults="Co-traveller's seat" />
  ),

  confirm: <Trans i18nKey="text.confirm" defaults="Confirm" />,
  confirmRegistration: (
    <Trans i18nKey="text.confirmRegistration" defaults="Confirm registration" />
  ),
  confirmRegistrationDescription: (
    <Trans
      i18nKey="text.confirmRegistrationDescription"
      defaults="We have sent you a verification email. To continue, please click on the verification link provided in that email. If you haven't received it, please check your spam folder or click on the resend link below."
    />
  ),
  continue: <Trans i18nKey="text.continue" defaults="Continue" />,
  continueWithEmail: (
    <Trans i18nKey="text.continueWithEmail" defaults="Continue with email" />
  ),
  createAPassword: (
    <Trans i18nKey="text.createAPassword" defaults="Create a password" />
  ),
  createAnAccount: (
    <Trans i18nKey="text.createAnAccount" defaults="Create an account" />
  ),
  createNewPassword: (
    <Trans i18nKey="text.createNewPassword" defaults="Create new password" />
  ),
  deckIndex: <Trans i18nKey="text.deckIndex" defaults="Deck {{index}}" />,
  deleteSeatChangeDescription: (
    <Trans
      i18nKey="text.deleteSeatChangeDescription"
      defaults="Are you sure you want to remove selected seat? You will be automatically assigned a new seat, which may be different than your original seat."
    />
  ),
  deleteSeatChangeTitle: (
    <Trans
      i18nKey="text.deleteSeatChangeTitle"
      defaults="Remove selected seat"
    />
  ),
  departure: <Trans i18nKey="text.departure" defaults="Departure" />,
  details: <Trans i18nKey="text.details" defaults="Details" />,
  direct: <Trans i18nKey="text.direct" defaults="Direct" />,
  discount: <Trans i18nKey="text.discount" defaults="Discount" />,
  dismiss: <Trans i18nKey="text.dismiss" defaults="Dismiss" />,
  dismissWarning: (
    <Trans i18nKey="text.dismissWarning" defaults="Dismiss warning" />
  ),
  doesntMatchCriteriaDescribedAbove: (
    <Trans
      i18nKey="text.doesntMatchCriteriaDescribedAbove"
      defaults="Doesn't match the criteria described above"
    />
  ),
  done: <Trans i18nKey="text.done" defaults="Done" />,
  download: <Trans i18nKey="text.download" defaults="Download" />,
  downloadTickets: (
    <Trans i18nKey="text.downloadTickets" defaults="Download tickets" />
  ),
  editSearch: <Trans i18nKey="text.editSearch" defaults="Edit search" />,
  email: <Trans i18nKey="text.email" defaults="Email" />,
  emailUsedForBooking: (
    <Trans
      i18nKey="text.emailUsedForBooking"
      defaults="Email (used for booking)"
    />
  ),
  enterYourBookingNumber: (
    <Trans
      i18nKey="text.enterYourBookingNumber"
      defaults="Enter your booking number"
    />
  ),
  enterYourEmailAddress: (
    <Trans
      i18nKey="text.enterYourEmailAddress"
      defaults="Enter your email address"
    />
  ),
  enterYourPassword: (
    <Trans i18nKey="text.enterYourPassword" defaults="Enter your password" />
  ),
  errorDownloadingPkpass: (
    <Trans
      i18nKey="text.errorDownloadingPkpass"
      defaults="Failed to download pkpass"
    />
  ),
  errorSendingEmail: (
    <Trans
      i18nKey="text.errorSendingEmail"
      defaults="Confirmation email not sent"
    />
  ),
  exchanged: <Trans i18nKey="text.exchanged" defaults="Exchanged" />,
  exempliGratia: <Trans i18nKey="text.exempliGratia" defaults="e.g." />,
  extras: <Trans i18nKey="text.extras" defaults="Extras" />,
  failedToCreateAccount: (
    <Trans
      i18nKey="text.failedToCreateAccount"
      defaults="Failed to create account."
    />
  ),
  failedToCreateBooking: (
    <Trans
      i18nKey="text.failedToCreateBooking"
      defaults="Failed to create booking."
    />
  ),
  fillOutFollowingRegistrationForm: (
    <Trans
      i18nKey="text.fillOutFollowingRegistrationForm"
      defaults="Please fill out the following registration form to sign up with us."
    />
  ),
  fillWithDataFrom: (
    <Trans i18nKey="text.fillWithDataFrom" defaults="Fill with data from" />
  ),
  findYourBooking: (
    <Trans i18nKey="text.findYourBooking" defaults="Find your booking" />
  ),
  firstName: <Trans i18nKey="text.firstName" defaults="First name" />,
  forgotPassword: (
    <Trans i18nKey="text.forgotPassword" defaults="Forgot password" />
  ),
  free: <Trans i18nKey="text.free" defaults="Free" />,
  from: <Trans i18nKey="text.from" defaults="From" />,
  front: <Trans i18nKey="text.front" defaults="Front" />,
  gender: <Trans i18nKey="text.gender" defaults="Gender" />,
  gladToHaveYouOnBoard: (
    <Trans
      i18nKey="text.gladToHaveYouOnBoard"
      defaults="Glad to have you on board!"
    />
  ),
  goBack: <Trans i18nKey="text.goBack" defaults="Go back" />,
  hello: <Trans i18nKey="text.hello" defaults="Hello!" />,
  helloDisplayName: (
    <Trans i18nKey="text.helloDisplayName" defaults="Hello, {{displayName}}" />
  ),
  history: <Trans i18nKey="text.history" defaults="History" />,
  importantInformation: (
    <Trans
      i18nKey="text.importantInformation"
      defaults="Important information"
    />
  ),
  insertYourEmail: (
    <Trans i18nKey="text.insertYourEmail" defaults="Insert your email" />
  ),
  invalidEmailFormat: (
    <Trans i18nKey="text.invalidEmailFormat" defaults="Invalid email format" />
  ),
  invalidPhoneNumberFormat: (
    <Trans
      i18nKey="text.invalidPhoneNumberFormat"
      defaults="Invalid phone number format"
    />
  ),
  journeyTransfersCount: (
    <Trans
      i18nKey="text.journeyTransfersCount"
      defaults="(0)[{{count}} transfers];(1)[{{count}} transfer];(2-inf)[{{count}} transfers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  lastName: <Trans i18nKey="text.lastName" defaults="Last name" />,
  leg: <Trans i18nKey="text.leg" defaults="Leg" />,
  legs: <Trans i18nKey="text.legs" defaults="Legs" />,
  logIn: <Trans i18nKey="text.logIn" defaults="Log in" />,
  logOut: <Trans i18nKey="text.logOut" defaults="Log out" />,
  loginFailed: <Trans i18nKey="text.loginFailed" defaults="Login failed" />,
  loyalty: <Trans i18nKey="text.loyalty" defaults="Loyalty" />,
  manageBooking: (
    <Trans i18nKey="text.manageBooking" defaults="Manage booking" />
  ),
  maximum64: (
    <Trans
      i18nKey="text.maximum64"
      defaults="Can not be more than 64 characters long"
    />
  ),
  minimumEight: (
    <Trans
      i18nKey="text.minimumEight"
      defaults="Must be at least 8 characters long"
    />
  ),
  minimumOne: (
    <Trans i18nKey="text.minimumOne" defaults="Must choose at least one" />
  ),
  minutesCount: (
    <Trans
      i18nKey="text.minutesCount"
      defaults="(0)[{{count}} minutes];(1)[{{count}} minute];(2-inf)[{{count}} minutes];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  mustBeFilled: <Trans i18nKey="text.mustBeFilled" defaults="Must be filled" />,
  mustChooseLeg: (
    <Trans i18nKey="text.mustChooseLeg" defaults="You must choose a leg" />
  ),
  next: <Trans i18nKey="text.next" defaults="Next" />,
  nextAvailableDates: (
    <Trans
      i18nKey="text.nextAvailableDates"
      defaults="Next available dates: {{departureDate}} - {{returnDate}}"
    />
  ),
  nextAvailableDepartureDate: (
    <Trans
      i18nKey="text.nextAvailableDepartureDate"
      defaults="Next available departure date: {{date}}"
    />
  ),
  nextAvailableReturnDate: (
    <Trans
      i18nKey="text.nextAvailableReturnDate"
      defaults="Next available return date: {{date}}"
    />
  ),
  new: <Trans i18nKey="text.new" defaults="New" />,
  noCountryFound: (
    <Trans i18nKey="text.noCountryFound" defaults="No country found" />
  ),
  noActiveTravelPasses: (
    <Trans
      i18nKey="text.noActiveTravelPasses"
      defaults="No active travel passes"
    />
  ),
  noHistoryTickets: (
    <Trans i18nKey="text.noHistoryTickets" defaults="No history of tickets" />
  ),
  noHistoryTravelPasses: (
    <Trans
      i18nKey="text.noHistoryTravelPasses"
      defaults="No history of travel passes"
    />
  ),
  noUpcomingTickets: (
    <Trans i18nKey="text.noUpcomingTickets" defaults="No upcoming tickets" />
  ),
  noExtrasAdded: (
    <Trans i18nKey="text.noExtrasAdded" defaults="No extras added" />
  ),
  noSeatSelectionAvailable: (
    <Trans
      i18nKey="text.noSeatSelectionAvailable"
      defaults="No seat selection available"
    />
  ),
  noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain: (
    <Trans
      i18nKey="text.noTravelPassesFoundPleaseChangeSearchInputsAndTryAgain"
      defaults="No travel passes found. Please change the search inputs and try again."
    />
  ),
  noTripsFoundPleaseChangeSearchInputsAndTryAgain: (
    <Trans
      i18nKey="text.noTripsFoundPleaseChangeSearchInputsAndTryAgain"
      defaults="No trips found. Please change the search inputs and try again."
    />
  ),
  noVouchersApplied: (
    <Trans i18nKey="text.noVouchersApplied" defaults="No vouchers applied" />
  ),
  nonRefundable: (
    <Trans i18nKey="text.nonRefundable" defaults="Non-refundable" />
  ),
  notAvailable: <Trans i18nKey="text.notAvailable" defaults="Not available" />,
  notRegisteredYet: (
    <Trans i18nKey="text.notRegisteredYet" defaults="Not registered yet?" />
  ),
  optional: <Trans i18nKey="text.optional" defaults="optional" />,
  outbound: <Trans i18nKey="text.outbound" defaults="Outbound" />,
  outboundTrip: <Trans i18nKey="text.outboundTrip" defaults="Outbound trip" />,
  outboundTrips: (
    <Trans
      i18nKey="text.outboundTrips"
      defaults="(0)[Outbound trips];(1)[Outbound trip];(2-inf)[Outbound trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  partiallyCancelled: (
    <Trans i18nKey="text.partiallyCancelled" defaults="Partially cancelled" />
  ),
  partiallyRefunded: (
    <Trans i18nKey="text.partiallyRefunded" defaults="Partially refunded" />
  ),
  passenger: <Trans i18nKey="text.passenger" defaults="Passenger" />,
  passengerIndex: (
    <Trans
      i18nKey="text.passengerIndex"
      defaults="(0)[Passenger];(1-inf)[Passenger {{count}}];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  passengers: <Trans i18nKey="text.passengers" defaults="Passengers" />,
  passengersCount: (
    <Trans
      i18nKey="text.passengersCount"
      defaults="(0)[{{count}} passengers];(1)[{{count}} passenger];(2-inf)[{{count}} passengers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  password: <Trans i18nKey="text.password" defaults="Password" />,
  passwordsMustMatch: (
    <Trans i18nKey="text.passwordsMustMatch" defaults="Passwords must match" />
  ),
  pay: <Trans i18nKey="text.pay" defaults="Pay" />,
  payer: <Trans i18nKey="text.payer" defaults="Payer" />,
  payment: <Trans i18nKey="text.payment" defaults="Payment" />,
  phoneNumber: <Trans i18nKey="text.phoneNumber" defaults="Phone number" />,
  pressHereToSearch: (
    <Trans i18nKey="text.pressHereToSearch" defaults="Press here to search" />
  ),
  priceIsForAllPassengers: (
    <Trans
      i18nKey="text.priceIsForAllPassengers"
      defaults="The price covers all passengers."
    />
  ),
  pricePerPassenger: (
    <Trans i18nKey="text.pricePerPassenger" defaults="Price per passenger " />
  ),
  pricesDisplayedInCurrency: (
    <Trans
      i18nKey="text.pricesDisplayedInCurrency"
      defaults="Prices displayed in {{currency}}"
    />
  ),
  promoCode: <Trans i18nKey="text.promoCode" defaults="Promo code" />,
  purchase: <Trans i18nKey="text.purchase" defaults="Purchase" />,
  readMore: <Trans i18nKey="text.readMore" defaults="Read more" />,
  refund: <Trans i18nKey="text.refund" defaults="Refund" />,
  refundFee: <Trans i18nKey="text.refundFee" defaults="Refund fee" />,
  refundInitiated: (
    <Trans
      i18nKey="text.refundInitiated"
      defaults="Trip successfully cancelled. Your refund will be issued in 3 business days."
    />
  ),
  refundIssuedText: (
    <Trans
      i18nKey="text.refundIssuedText"
      defaults="The refund will be issued to the card that was used to pay for the booking."
    />
  ),
  refundTravelPasses: (
    <Trans
      i18nKey="text.refundTravelPasses"
      defaults="(1)[Refund travel pass];(2-inf)[Refund travel passes]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  refundTrips: (
    <Trans
      i18nKey="text.refundTrips"
      defaults="(1)[Refund trip];(2-inf)[Refund trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  refundable: <Trans i18nKey="text.refundable" defaults="Refundable" />,
  refunded: <Trans i18nKey="text.refunded" defaults="Refunded" />,
  remainingUses: (
    <Trans i18nKey="text.remainingUses" defaults="Remaining uses" />
  ),
  remove: <Trans i18nKey="text.remove" defaults="Remove" />,
  repeatNewPassword: (
    <Trans i18nKey="text.repeatNewPassword" defaults="Repeat new password" />
  ),
  requiredField: (
    <Trans i18nKey="text.requiredField" defaults="Required field" />
  ),
  resendConfirmationEmail: (
    <Trans
      i18nKey="text.resendConfirmationEmail"
      defaults="Resend confirmation email"
    />
  ),
  resendTheLinkViaEmail: (
    <Trans
      i18nKey="text.resendTheLinkViaEmail"
      defaults="Resend the link via email"
    />
  ),
  reservedSeats: (
    <Trans i18nKey="text.reservedSeats" defaults="Reserved seats" />
  ),
  resetPassword: (
    <Trans i18nKey="text.resetPassword" defaults="Reset password" />
  ),
  resetYourPassword: (
    <Trans i18nKey="text.resetYourPassword" defaults="Reset your password" />
  ),
  return: <Trans i18nKey="text.return" defaults="Return" />,
  returnTrip: <Trans i18nKey="text.returnTrip" defaults="Return trip" />,
  returnTrips: (
    <Trans
      i18nKey="text.returnTrips"
      defaults="(1)[Return trip];(2-inf)[Return trips]"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  seatMapKey: <Trans i18nKey="text.seatMapKey" defaults="Seat map key" />,
  seatReservationNotAvailable: (
    <Trans
      i18nKey="text.seatReservationNotAvailable"
      defaults="Seat reservation is not available"
    />
  ),
  seatSelection: (
    <Trans i18nKey="text.seatSelection" defaults="Seat selection" />
  ),
  seatSelectionError: (
    <Trans i18nKey="text.seatSelectionError" defaults="Seat not available" />
  ),
  seatSelectionSuccess: (
    <Trans i18nKey="text.seatSelectionSuccess" defaults="Seat selected" />
  ),
  seatTypeUnavailable: (
    <Trans
      i18nKey="text.seatTypeUnavailable"
      defaults="Unavailable seat type"
    />
  ),
  secondsCount: (
    <Trans
      i18nKey="text.secondsCount"
      defaults="(0)[{{count}} seconds];(1)[{{count}} second];(2-inf)[{{count}} seconds];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  select: <Trans i18nKey="text.select" defaults="Select" />,
  selectExtras: <Trans i18nKey="text.selectExtras" defaults="Select extras" />,
  selectLanguage: (
    <Trans i18nKey="text.selectLanguage" defaults="Select language" />
  ),
  selectOutboundFare: (
    <Trans i18nKey="text.selectOutboundFare" defaults="Select outbound fare" />
  ),
  selectOutboundTrip: (
    <Trans i18nKey="text.selectOutboundTrip" defaults="Select outbound trip" />
  ),
  selectPassenger: (
    <Trans i18nKey="text.selectPassenger" defaults="Select passenger" />
  ),
  selectPassengersToRefund: (
    <Trans
      i18nKey="text.selectPassengersToRefund"
      defaults="Select passengers to refund"
    />
  ),
  selectReturnFare: (
    <Trans i18nKey="text.selectReturnFare" defaults="Select return fare" />
  ),
  selectReturnTrip: (
    <Trans i18nKey="text.selectReturnTrip" defaults="Select return trip" />
  ),
  selectSeats: <Trans i18nKey="text.selectSeats" defaults="Select seats" />,
  selectTravelPass: (
    <Trans i18nKey="text.selectTravelPass" defaults="Select travel pass" />
  ),
  selected: <Trans i18nKey="text.selected" defaults="Selected" />,
  selectedSeat: <Trans i18nKey="text.selectedSeat" defaults="Selected seat" />,
  sendToEmail: <Trans i18nKey="text.sendToEmail" defaults="Send to email" />,
  sessionAboutToExpire: (
    <Trans
      i18nKey="text.sessionAboutToExpire"
      defaults="Session about to expire"
    />
  ),
  showLess: <Trans i18nKey="text.showLess" defaults="Show less" />,
  showMore: <Trans i18nKey="text.showMore" defaults="Show more" />,
  signUp: <Trans i18nKey="text.signUp" defaults="Sign up" />,
  stopsCount: (
    <Trans
      i18nKey="text.stopsCount"
      defaults="(0)[{{count}} stops];(1)[{{count}} stop];(2-inf)[{{count}} stops];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  streetName: <Trans i18nKey="text.streetName" defaults="Street name" />,
  thankYou: <Trans i18nKey="text.thankYou" defaults="Thank you!" />,
  tickets: <Trans i18nKey="text.tickets" defaults="Tickets" />,
  total: <Trans i18nKey="text.total" defaults="Total" />,
  totalPrice: <Trans i18nKey="text.totalPrice" defaults="Total price" />,
  totalRefund: <Trans i18nKey="text.totalRefund" defaults="Total refund" />,
  totalRefunds: <Trans i18nKey="text.totalRefunds" defaults="Total refunds" />,
  train: <Trans i18nKey="text.train" defaults="Train" />,
  transfer: <Trans i18nKey="text.transfer" defaults="Transfer" />,
  transfersCount: (
    <Trans
      i18nKey="text.transfersCount"
      defaults="(0)[{{count}} transfers];(1)[{{count}} transfer];(2-inf)[{{count}} transfers];"
      tOptions={{ postProcess: 'interval' }}
    />
  ),
  transferTime: <Trans i18nKey="text.transferTime" defaults="transfer time" />,
  travelPass: <Trans i18nKey="text.travelPass" defaults="Travel pass" />,
  travelPassDetails: (
    <Trans i18nKey="text.travelPassDetails" defaults="Travel pass details" />
  ),
  travelPasses: <Trans i18nKey="text.travelPasses" defaults="Travel passes" />,
  tripLegPartIndex: (
    <Trans i18nKey="text.tripLegPartIndex" defaults="Part {{tripLegPart}}" />
  ),
  tripNumber: <Trans i18nKey="text.tripNumber" defaults="Trip {{number}}" />,
  unavailable: <Trans i18nKey="text.unavailable" defaults="Unavailable" />,
  unavailableSeat: (
    <Trans i18nKey="text.unavailableSeat" defaults="Unavailable seat" />
  ),
  unchangeable: <Trans i18nKey="text.unchangeable" defaults="Unchangeable" />,
  undefinedConsentDescription: (
    <Trans
      i18nKey="text.undefinedConsentDescription"
      defaults="Undefined consent description"
    />
  ),
  undo: <Trans i18nKey="text.undo" defaults="Undo" />,
  upcoming: <Trans i18nKey="text.upcoming" defaults="Upcoming" />,
  validFrom: <Trans i18nKey="text.validFrom" defaults="Valid from" />,
  validTo: <Trans i18nKey="text.validTo" defaults="Valid to" />,
  viewDetails: <Trans i18nKey="text.viewDetails" defaults="View details" />,
  viewTickets: <Trans i18nKey="text.viewTickets" defaults="View tickets" />,
  voucherCodeNotValid: (
    <Trans
      i18nKey="text.voucherCodeNotValid"
      defaults="Voucher code not valid"
    />
  ),
  vouchers: <Trans i18nKey="text.vouchers" defaults="Vouchers" />,
  weHaveSentYouTheLink: (
    <Trans
      i18nKey="text.weHaveSentYouTheLink"
      defaults="We have sent you a link to reset your password. If you haven't received it, please check your spam folder or click on the resend link below."
    />
  ),
  wheelchair: <Trans i18nKey="text.wheelchair" defaults="Wheelchair" />,
  wheelchairAccessible: (
    <Trans
      i18nKey="text.wheelchairAccessible"
      defaults="Wheelchair accessible"
    />
  ),
  externalPay: <Trans i18nKey="text.externalPay" defaults="Pay (external)" />,
  willSendYouTheLink: (
    <Trans
      i18nKey="text.willSendYouTheLink"
      defaults="We will send you the link to reset your password via email."
    />
  ),
  youAreAboutToRefundFollowingItems: (
    <Trans
      i18nKey="text.youAreAboutToRefundFollowingItems"
      defaults="You are about to refund the following items:"
    />
  ),
  yourPaymentIsBeingProcessedPleaseWait: (
    <Trans
      i18nKey="text.yourPaymentIsBeingProcessedPleaseWait"
      defaults="Your payment is being processed. Please wait..."
    />
  ),
});

export type TransTextKeys = TransKeys<typeof TransText>;
